import React from 'react'

const FIlterIcon = () => {
    return (
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 32.917 29.329">
                <path id="_1652628681582962172" data-name="1652628681582962172" d="M2.5,9.2v1.142L15.724,26.876H16.2V38.531L21.712,34.2V26.876h.477L35.415,10.344V9.2Z" transform="translate(-2.498 -9.202)" fill="#475969" />
            </svg>
        </div>
    )
}

export default FIlterIcon
